module.exports = __webpack_public_path__ + "static/media/bunzl-splash.c5b35a4d.jpg";